<template>
  <div v-if="showSeatInfo()" class="delivery-options m-b-20">
    <delivery-info></delivery-info>
    <app-link :route-to="{}" class="delivery-options__link" @click.prevent="routeToVendorList">
      Edit
    </app-link>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ROUTE_NAMES } from "../../../../utils";
import DeliveryInfo from "./delivery-info/DeliveryInfo";
import AppLink from "@/components/base/app-link/AppLink";

export default {
  name: "DeliveryOptions",
  components: { DeliveryInfo, AppLink },
  computed: {
    ...mapGetters({
      hasSeat: "level/isValid",
      vendorAliasPlural: "venue/getVendorAliasPlural",
      seatRequired: "venueSettings/seatRequired"
    })
  },
  methods: {
    showSeatInfo() {
      return this.hasSeat && this.seatRequired;
    },
    routeToVendorList() {
      this.$router.push({
        name: ROUTE_NAMES.VENUE_CONTAINER,
        params: {
          returnTo: ROUTE_NAMES.SHOPPING_CART
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.delivery-options {
  display: flex;
  flex-direction: row;
  align-items: flex-end;

  &__link {
    line-height: 20px;
    font-size: 14px;
    font-family: $group-3-font-family-1;
    color: $group-3-color-4;
    font-weight: bold;
  }
}
</style>
